module.exports = "<a class=\"prev-btn nav-btn\"><i class=\"fa fa-angle-left q-icon-md q-marg-right-xs\" aria-hidden=true></i>Previous</a> {%= pageNumTray %} <a class=\"next-btn nav-btn q-pad-left-til-md\">Next<i class=\"fa fa-angle-right q-icon-md q-marg-left-xs\" aria-hidden=true></i></a>";


//////////////////
// WEBPACK FOOTER
// ./src/components/pagableComponent/html/pagingButtons.html
// module id = 1166
// module chunks = 1